import Button from "@common/controls/Button/component";
import ButtonsContainer from "@common/controls/Container/Buttons";
import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import classNames from "classnames";
import { omit } from "lodash";
import { type Moment } from "moment";
import React, { Component } from "react";
import Calendar from "./panels/Calendar";
import Shortcuts from "./panels/Shortcuts";
import Time from "./panels/Time";

export interface PickerProps {
  className?: string;
  isOpen?: boolean;
  minDate?: Moment | null;
  maxDate?: Moment | null;
  shortcuts?: string[];
  splitPanel?: boolean;
  showClear: boolean;
  showTimePicker?: boolean;
  showCalendarPicker?: boolean;

  moment: Moment | null;
  onChange: (value: Moment | null) => void;
}
interface State {
  panel: string;
}
class Picker extends Component<PickerProps, State> {
  public state: State = {
    panel: "calendar"
  };

  public changePanel = (panel) => {
    this.setState({
      panel
    });
  };

  private _onClearClick = () => {
    this.props.onChange(null);
  };

  public render() {
    const {
      isOpen = true,
      shortcuts,
      showClear,
      splitPanel,
      showTimePicker = true,
      showCalendarPicker = true
    } = this.props;
    const { panel } = this.state;
    const isTimePanel = panel === "time";
    const isCalendarPanel = panel === "calendar";
    const className = classNames("datetime-picker", this.props.className, {
      split: splitPanel,
      time_only: showTimePicker && !showCalendarPicker
    });
    const props = omit(this.props, "className", "splitPanel", "isOpen");

    return (
      <div
        className={className}
        style={{ display: isOpen ? "block" : "none" }}
        onClick={(evt) => evt.stopPropagation()}
      >
        {shortcuts ? <Shortcuts {...props} /> : undefined}

        {splitPanel ? (
          <div className="panel-nav">
            <button
              type="button"
              onClick={this.changePanel.bind(this, "calendar")}
              className={isCalendarPanel ? "active" : ""}
            >
              <Icon icon={IconType.Calendar} />
              Date
            </button>
            <button type="button" onClick={this.changePanel.bind(this, "time")} className={isTimePanel ? "active" : ""}>
              <Icon icon={IconType.Clock} />
              Time
            </button>
          </div>
        ) : undefined}

        {showCalendarPicker ? (
          <Calendar
            {...props}
            isOpen={isOpen}
            style={{
              display: isCalendarPanel || !splitPanel ? "block" : "none"
            }}
          />
        ) : undefined}

        {showTimePicker ? (
          <Time {...props} style={{ display: isTimePanel || !splitPanel ? "block" : "none" }} />
        ) : undefined}

        {showClear && (
          <ButtonsContainer>
            <Button className="btn-light" onClick={this._onClearClick}>
              Clear
            </Button>
          </ButtonsContainer>
        )}
      </div>
    );
  }
}

export default Picker;
